import { ModalName } from '@/constants/modals';
import { MobileAppStatus } from '@/modules/worker/types';

import type { WorkerPool } from '@/modules/companyNeed/views/details/pool/types';

import { useModalStore } from '@/dsComponents/modals/modalStore';

export interface CompanyNeedSourceWorker {
	id: string;
	firstname?: string;
	lastname?: string;
	picture?: string | null;
	email?: string;
	phone?: string;
	delegable: boolean;
	mobileAppStatus?: string | null;
}

export const buildPendingPoolWorker = (
	worker: CompanyNeedSourceWorker
): WorkerPool => ({
	workerId: worker.id,
	firstname: worker.firstname ?? '',
	lastname: worker.lastname ?? '',
	avatarUrl: worker.picture ?? null,
	delegable: worker.delegable,
	registered: worker.mobileAppStatus === MobileAppStatus.REGISTERED,
	lastUpdate: null,
	phone: worker.phone ?? '',
	email: worker.email ?? '',
	missionWithClient: 0,
	distance: 0,
	experienceLevel: null,
	unavailability: null,
	ongoingProposals: [],
});

export const openCreateCompanyNeedFromWorkers = (
	workers: CompanyNeedSourceWorker[]
): void => {
	useModalStore().actions.open(ModalName.SearchCompanyNeedsModal, {
		workers,
	});
};
